import { Injectable } from '@angular/core';
import {Router} from '@angular/router';
import {Device} from 'src/app/infrastructure/device/device';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerIoService {
  constructor(
    private router: Router,
    private device: Device
  ) {}

  addCustomerIoScript(siteId: string, userId: string, data: object) {
    if (!this.shouldIncludeCustomerIoScript()) {
      return;
    }

    /* eslint-disable */
    if ((window as any)._cio && Array.isArray((window as any)._cio)) {
      return;
    }

    // @ts-ignore
    const _cio = [] || _cio;
    (window as any)._cio = _cio;

    let c: number;


    const a: (f: string) => (...args: any[]) => void = function(f) {
      return function(...args: any[]) {
        _cio.push([f].concat(args));
      };
    };

    const b: string[] = ['load', 'identify', 'sidentify', 'track', 'page', 'on', 'off'];
    for (c = 0; c < b.length; c++) {
      _cio[b[c]] = a(b[c]);
    }
    /* eslint-enable */

    const t = document.createElement('script');
    const s = document.getElementsByTagName('script')[0];
    t.async = true;
    t.id = 'cio-tracker';
    t.setAttribute('data-site-id', siteId);
    t.setAttribute('data-use-array-params', 'true');
    t.setAttribute('data-use-in-app', 'true');
    t.src = 'https://assets.customer.io/assets/track.js';
    s.parentNode.insertBefore(t, s);

    _cio.identify({
      id: userId,
      data
    });

    this.initInAppListener();
  }

  public initInAppListener() {
    // eslint-disable-next-line no-underscore-dangle
    const _cio = (window as any)._cio;
    if (!_cio || typeof _cio.on !== 'function') {
      console.warn('Customer.io not initialized yet');
      return;
    }

    _cio.on('in-app:message-action', (payload: any) => {

      const url = payload?.detail.action;
      if (url) {
        if (url.startsWith('https://app.finizens.com/') && this.device.isApp()) {
          const path = url.replace('https://app.finizens.com/', '/');
          this.router.navigate([path]);
          payload.message?.dismiss?.();
          payload.detail.message?.dismiss?.();
          return;
        }
        window.open(url, '_blank');
        payload.message?.dismiss?.();
        payload.detail.message?.dismiss?.();
      }
    });
  }

  public trackPushOpened(deliveryId: string) {
    if (!this.shouldIncludeCustomerIoScript()) {
      return;
    }

    // eslint-disable-next-line no-underscore-dangle
    const _cio = (window as any)._cio;
    if (!_cio || typeof _cio.track !== 'function') {
      // The Customer.io script is not loaded correctly
      return;
    }

    _cio.track({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      delivery_id: deliveryId,
      timestamp: Math.floor(Date.now() / 1000),
      metric: 'opened',
    });
  }

  private shouldIncludeCustomerIoScript(): boolean {
    return environment.analytics.customerIoSiteId !== null;
  }
}
